import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./styles/tokens.css"; // HLOS-74 (HLOS-68-D): design tokens (cores)
import "./styles/a11y.css"; // Fase 0: acessibilidade (font/contrast/cb/slow)

/**
 * HLOS UI Shell v0.2 — Entry point (apps/ui-shell).
 *
 * HLOS-2 (HLOS-102): registra Pinia para os 5 bounded contexts
 * (presence, context, session, initiative, conversation).
 * Mantido mínimo em v0.2:
 * - Sem Vue Router (state machine em App.vue é preferida em v1).
 * - Sem plugins Capacitor aqui — entram em HLOS-5.
 *
 * Princípio XI (Companion ≠ LLM): o boot NÃO inicializa nenhum LLM.
 */
const app = createApp(App);
app.use(createPinia());

// Fase 0 (Acessibilidade): aplicar preferências de UI ao <html> no boot.
// CL-07: prefs ficam em localStorage, fora do vault.
import { useAccessibilityStore } from "./accessibility/store";
const a11y = useAccessibilityStore();
a11y.init();

app.mount("#app");
